import {i18n} from '@/plugins/i18n'

export const moneyRequestStatus = {
    INIT: 0,
    SUCCEEDED: 1,
    FAILED: 2,
    CANCELLED: 3,
    CANCELLED_BY_ADMIN: 4,
    PAID: 5,
};

export const moneyRequestStatusStr = {
    INIT: i18n.t('label.money_request_status.init'),
    SUCCEEDED: i18n.t('label.money_request_status.succeeded'),
    FAILED: i18n.t('label.money_request_status.failed'),
    CANCELLED: i18n.t('label.money_request_status.cancelled'),
    CANCELLED_BY_ADMIN: i18n.t('label.money_request_status.cancelled_by_admin'),
    PAID: i18n.t('label.money_request_status.paid'),

    get(status) {
        let status_str = null;

        Object.keys(moneyRequestStatus).forEach(item => {
            if (moneyRequestStatus[item] === status) {
                status_str = moneyRequestStatusStr[item];
            }
        });

        return status_str;
    }
};

export const moneyRequestStatusVariant = status => {
    switch (status) {
        case moneyRequestStatus.PAID:
        case moneyRequestStatus.SUCCEEDED:
            return 'success';
        case moneyRequestStatus.CANCELLED:
        case moneyRequestStatus.CANCELLED_BY_ADMIN:
        case moneyRequestStatus.FAILED:
            return 'danger';
        case moneyRequestStatus.INIT:
            return 'warning';
    }

    return 'primary';
};
